import { CategoryOrBuyingOption } from 'services/categories/types';
import { mappedCategoryOrBuyingOption } from './types';
import {
  CAT_CARD_MENU_CRITERIA_COUNTRY,
  CAT_CARD_MENU_CRITERIA_LANG_ID
} from './constant';

export const setColumns = (
  unvalidatedList: Array<mappedCategoryOrBuyingOption>
) => {
  const list = Array.isArray(unvalidatedList) ? [...unvalidatedList] : [];
  const COLUMN_LENGTH = Math.ceil(list.length / 3);
  const firstColumn = list.splice(0, COLUMN_LENGTH);
  const secondColumn = list.splice(
    0,
    COLUMN_LENGTH === list.length ? Math.ceil(list.length / 2) : COLUMN_LENGTH
  );
  return [
    { key: 1, data: firstColumn },
    { key: 2, data: secondColumn },
    { key: 3, data: list }
  ];
};

export const prepareColumns = ({
  categories,
  buyingOptions
}: {
  categories: Array<mappedCategoryOrBuyingOption>;
  buyingOptions: Array<mappedCategoryOrBuyingOption>;
}) => {
  return {
    preparedCategories: setColumns(categories),
    preparedBuyingOptions: setColumns(buyingOptions)
  };
};

export const reMapKeys = (data: Array<CategoryOrBuyingOption>) => {
  const reMapData = data.map((item) => {
    return { name: item.name, seoURL: item.seoUrlKeyword };
  });
  return reMapData;
};

export const validateIfActive = ({
  url = '',
  pathname = ''
}: {
  url: string;
  pathname: string;
}) => {
  const currentRoute = url?.split('/').slice(-1)[0];
  const currentPage = pathname?.split('/').slice(-1)[0];
  return currentPage?.replace(/-/g, '') === currentRoute?.replace(/-/g, '');
};

export const isCatCardMenu = (country, locale) => {
  return !!(
    country === CAT_CARD_MENU_CRITERIA_COUNTRY[country] &&
    locale === CAT_CARD_MENU_CRITERIA_LANG_ID[locale]
  );
};
